import React, { useEffect, useState } from "react";
import { useDialog } from "../../../licensing/utils/DialogProvider";
import axios from "axios";
import Vestiging from "../../../licensing/Models/Vestiging";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import Venue from "../../../licensing/Models/Venue";
import CreateVenue from "../../../licensing/Views/Venues/CreateVenue";
import AsynchronousAutocomplete from "../../../components/Autocomplete/AsynchronousAutocomplete";

function SalesAreasWithoutVenues(props) {
  const [salesAreasWithoutVenues, setSalesAreasWithoutVenues] = useState(null);
  const [paginationData, setPaginationData] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [openDialog] = useDialog();

  useEffect(() => {
    setSalesAreasWithoutVenues(null);
    axios
      .post(`core/SubsDashboard/salesareasWithoutVenues?per_page=${rowsPerPage}&page=${page + 1}`)
      .then((response) => {
        setPaginationData({
          total: response.data.data.total,
        });
        setSalesAreasWithoutVenues(
          response.data.data.data.map((salesAreaData) => Vestiging.CreateModel(salesAreaData))
        );
      });
  }, [page, rowsPerPage]);

  const updateSalesAreas = (salesArea) => {
    setTimeout(() => {
      if (salesAreasWithoutVenues) {
        let newSalesAreas = [...salesAreasWithoutVenues];
        let index = salesAreasWithoutVenues.findIndex((option) => option.id === salesArea.id);
        if (index >= 0) {
          newSalesAreas.splice(index, 1);
          setSalesAreasWithoutVenues(newSalesAreas);
        }
      }
    }, 1000);
  };

  return (
    <Card>
      <CardHeader title={"Vestigingen zonder Venues"} />
      <CardContent style={{ textAlign: "center" }}>
        {salesAreasWithoutVenues != null ? (
          <>
            <Table size={"small"}>
              <TableHead>
                <TableRow style={{ fontWeight: 800 }}>
                  <TableCell style={{ fontWeight: 800 }}>#</TableCell>
                  <TableCell style={{ fontWeight: 800 }}>Sales Area</TableCell>
                  <TableCell style={{ fontWeight: 800 }}>Koppel aan venue</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {salesAreasWithoutVenues?.map((salesArea) => {
                  return (
                    <TableRow key={salesArea.id}>
                      <TableCell>{salesArea.id}</TableCell>
                      <TableCell>{salesArea.systeemNaam}</TableCell>
                      <TableCell>
                        <div style={{ display: "flex" }}>
                          <AsynchronousAutocomplete
                            async={{
                              url: "core/venue/search?fields=id as value, name as label&per_page=50",
                              searchField: "name",
                            }}
                            disableClearable={true}
                            onChange={(e, option) => {
                              salesArea.apiUpdate({ venue_id: option.value }).then(() => {
                                updateSalesAreas(salesArea);
                              });
                            }}
                          />

                          <Button
                            color={"primary"}
                            onClick={() => {
                              openDialog({
                                children: (
                                  <CreateVenue
                                    onChange={(venue) => {
                                      return new Promise((resolve, reject) => {
                                        venue
                                          .apiCreate()
                                          .then(({ model }) => {
                                            resolve(model);
                                            salesArea.apiUpdate({ venue_id: model.id }).then(({ model }) => {
                                              updateSalesAreas(salesArea);
                                            });
                                          })
                                          .catch((e) => {
                                            console.log(e);
                                            reject();
                                          });
                                      });
                                    }}
                                    venue={
                                      new Venue(
                                        0,
                                        salesArea.systeemNaam,
                                        (salesArea.street ?? "") + " " + (salesArea.houseNumber ?? ""),
                                        salesArea.city,
                                        salesArea.postalCode,
                                        salesArea.country,
                                        salesArea.tel,
                                        salesArea.email,
                                        "",
                                        salesArea.btwnummer,
                                        salesArea.kvk
                                      )
                                    }
                                  />
                                ),
                              });
                            }}
                            size={"small"}
                            variant={"outlined"}
                          >
                            Create
                          </Button>
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            <TablePagination
              component={"div"}
              count={paginationData?.total}
              onPageChange={(e, newPage) => {
                setPage(newPage);
              }}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(parseInt(e.target.value));
              }}
              page={page}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[5, 10, 25]}
              showFirstButton
              showLastButton
            />
          </>
        ) : null}
        {salesAreasWithoutVenues == null ? <CircularProgress /> : null}
      </CardContent>
    </Card>
  );
}

export default SalesAreasWithoutVenues;
